import apiClient from '../../../common/services/apiClient';
import { createQueryString } from '../../../common/utils/helpers';

export const apiCallIds = {
  FETCH_DISPOSALS: 'FETCH_DISPOSALS',
};

export default {
  fetchDisposals: options => {
    return apiClient.get(`/disposals?${createQueryString(options)}`, {
      apiCallId: apiCallIds.FETCH_DISPOSALS,
    });
  },
};



// WEBPACK FOOTER //
// ./src/features/disposals/api/index.js